import { defineStore } from '/src/core/store';

export const useAuthStore = defineStore('auth', {
	state: () => ({
		token: null,
		authenticated: false,
		backSubdomain: import.meta.env.VITE_API_SUBDOMAIN,
		streamSubdomain: import.meta.env.VITE_STREAM_SUBDOMAIN,
	}),
	persist: {
		storage: 'native',
		pick: ['token', 'backSubdomain', 'streamSubdomain'],
	},
	actions: {
		setToken (token) {
			this.token = token;
		},
		setAuthenticated (authenticated) {
			this.authenticated = authenticated;
		},
		setBackSubdomain (backSubdomain) {
			this.backSubdomain = backSubdomain;
		},
		setStreamSubdomain (streamSubdomain) {
			this.streamSubdomain = streamSubdomain;
		},
		reset () {
			this.setToken(null);
			this.setAuthenticated(false);
			this.setBackSubdomain(import.meta.env.VITE_API_SUBDOMAIN);
			this.setStreamSubdomain(import.meta.env.VITE_STREAM_SUBDOMAIN);

			window.location.reload();
		},
	},
	sockets: {
		CompanyDeviceDeleted () {
			this.reset();
		},
	},
});
